import { GoogleMap, Marker } from "@react-google-maps/api";


const MapLocationComponent = ({ lat, lng }) => {

    const containerStyle = {
        width: "100%",
        height: "114px",
        borderRadius: "16px"
    };
    const center = {
        lat: lat,
        lng: lng,
    };
    return (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={4}>
            <Marker position={center} />
        </GoogleMap>
    );
};

export default MapLocationComponent;
